import { Link, NavLink } from "react-router-dom";
import { Brand } from "./Brand";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Product", anchor: "#features" },
  { to: "/", label: "How it works", anchor: "#how" },
  { to: "/pricing", label: "Pricing" },
  { to: "/", label: "Customers", anchor: "#testimonials" },
  { to: "/contact", label: "Contact" },
];

export default function MarketingHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#FAFAF7]/85 border-b border-[#EAEAE3]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Brand />
        <nav className="hidden md:flex items-center gap-9 text-sm">
          {NAV.map((item) =>
            item.anchor ? (
              <a key={item.label} href={`${item.to}${item.anchor}`} className="text-[#5C5C66] hover:text-[#0A0A0F] transition-colors">
                {item.label}
              </a>
            ) : (
              <NavLink key={item.label} to={item.to} className={({ isActive }) => `transition-colors ${isActive ? "text-[#0A0A0F] font-medium" : "text-[#5C5C66] hover:text-[#0A0A0F]"}`} data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}>
                {item.label}
              </NavLink>
            )
          )}
        </nav>
        <div className="hidden md:flex items-center gap-2">
          <Link to="/login" data-testid="nav-login">
            <Button variant="ghost" className="rounded-lg text-[#0A0A0F] hover:bg-[#F4F4EE]">Sign in</Button>
          </Link>
          <Link to="/signup" data-testid="nav-signup">
            <Button className="rounded-lg bg-[#0A0A0F] hover:bg-[#14141B] text-white font-medium">
              Get started
            </Button>
          </Link>
        </div>
        <button className="md:hidden text-[#0A0A0F]" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#EAEAE3] bg-[#FAFAF7] px-6 py-4 space-y-3">
          {NAV.map((item) => (
            <a key={item.label} href={`${item.to}${item.anchor || ""}`} onClick={() => setOpen(false)} className="block text-[#5C5C66]">{item.label}</a>
          ))}
          <div className="flex gap-2 pt-2 border-t border-[#EAEAE3]">
            <Link to="/login" className="flex-1"><Button variant="outline" className="w-full rounded-lg">Sign in</Button></Link>
            <Link to="/signup" className="flex-1"><Button className="w-full rounded-lg bg-[#0A0A0F] text-white">Get started</Button></Link>
          </div>
        </div>
      )}
    </header>
  );
}
